
import { usePropertyFeatures } from '@/hooks/useFeatures';

interface PropertyAmenitiesProps {
  propertyId: string;
}

const PropertyAmenities = ({ propertyId }: PropertyAmenitiesProps) => {
  const { data: features = [], isLoading } = usePropertyFeatures(propertyId);

  if (isLoading) {
    return (
      <div className="py-6 border-b border-gray-200">
        <h3 className="text-xl font-semibold mb-6">Lo que este lugar ofrece</h3>
        <div className="text-sm text-gray-500">Cargando características...</div>
      </div>
    );
  }

  if (features.length === 0) {
    return (
      <div className="py-6 border-b border-gray-200">
        <h3 className="text-xl font-semibold mb-6">Lo que este lugar ofrece</h3>
        <p className="text-gray-500">No hay características disponibles para esta propiedad.</p>
      </div>
    );
  }

  return (
    <div className="py-6 border-b border-gray-200">
      <h3 className="text-xl font-semibold mb-6">Lo que este lugar ofrece</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {features.map((feature) => (
          <div key={feature.id} className="flex items-center">
            <span className="text-gray-700">{feature.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyAmenities;
